// OrderSummaryBadge.js
import React from "react";
// MATERIAL UI
import { StyledGreyBadgeNoBackgroundOnPrint } from "../styled/badge";
import { TypographyBoldOnPrint } from "../styled";

const LabelToValueHorizontal = ({
  label,
  value,
  isbold,
  isLight = false,
  backgroundColor = "transparent",
}) => {
  return (
    <StyledGreyBadgeNoBackgroundOnPrint
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      backgroundcolor={backgroundColor}
    >
      <TypographyBoldOnPrint
        variant="body1"
        textAlign="center"
        fontWeight={isbold ? "bold" : isLight ? "light" : "normal"}
        printsize={10}
        sx={{ ml: 1 }}
      >
        {label}
      </TypographyBoldOnPrint>
      <TypographyBoldOnPrint
        variant="body1"
        textAlign="center"
        fontWeight={isbold ? "bold" : isLight ? "light" : "normal"}
        printsize={10}
        sx={{ ml: 1 }}
      >
        {value}
      </TypographyBoldOnPrint>
    </StyledGreyBadgeNoBackgroundOnPrint>
  );
};

export default LabelToValueHorizontal;
